import { cartItemIds } from './cartItemIds';
import { getLanguageKey } from './getLanguageKey';
import { searchConfig } from './getSearchConfig';
import { isEuEnv } from '../../../../../../../../../code/MaterialBank/ReactComponents/view/frontend/web/js/mb/lib';
import { Customer } from '../../../../../../../../../code/MaterialBank/ReactComponents/view/frontend/web/js/mb-frontend/src/entities/customer';

const PAINT_CATEGORY_NAMES = ['paints', 'paint'];

function isPaintCartItem(item: any): boolean {
  const taxonomy = item?.taxonomy_us || '';
  const category = taxonomy.split(/[.|>]/)?.[1]?.toLowerCase() || '';
  return PAINT_CATEGORY_NAMES.includes(category);
}

function isPaintOnlyCart(cartItems: any[]): boolean {
  if (!cartItems || cartItems.length === 0) {
    return false;
  }
  return cartItems.every(isPaintCartItem);
}

export async function checkRecommend(cartItems: any, customer: any) {
  const COOKIE_NAME = 'mbSkipAssistant';
  const PREVIOUS_CART_COUNT = 'previousCartCount';

  // get previous cart count
  let previousCartCount = Number(sessionStorage.getItem(PREVIOUS_CART_COUNT));
  if (isNaN(previousCartCount)) {
    previousCartCount = 0;
  }

  if (cartItems.length < previousCartCount) {
    // leave cookie what it was
    return;
  }

  // remove cookie
  document.cookie = `${COOKIE_NAME}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;`;

  if (cartItems.length === 0) {
    return;
  }

  // US paint-only cart: interruptor page renders static category thumbnails
  // and is shown unconditionally. Skip the recommendation check so the
  // mbSkipAssistant cookie stays cleared and the redirect fires.
  if (!isEuEnv && isPaintOnlyCart(cartItems)) {
    return;
  }

  await fetch(searchConfig.siteUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      ...getBgFilter(customer),
      customer: {
        email: customer ? customer.email : '',
        projectId: customer ? parseInt(customer.current_project, 10) : 0,
        country: customer ? customer.country : '',
        province: customer ? customer.state : '',
      },
      id: cartItemIds(cartItems),
      siteId: searchConfig.siteId,
      sku: [],
      filters: [
        {
          field: 'is_orderable',
          value: ['true'],
        },
        {
          field: 'is_finish',
          value: ['false'],
        },
      ],
      context: searchConfig.context,
      lang: getLanguageKey(),
      extraFields: [],
      forceFamily: false,
      qty: 1,
      exclude: cartItemIds(cartItems),
      version: 11,
      type: 'cart',
      referrerUrl: `${window.location.hostname}${window.location.pathname}`,
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data === null) {
        document.cookie = `${COOKIE_NAME}=1; path=/`;
      } else {
        document.cookie = `${COOKIE_NAME}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
      }
    })
    .catch(() => {
      document.cookie = `${COOKIE_NAME}=1; path=/`;
    });
}

function getBgFilter(customer: Partial<Customer>) {
  const bgfilter: Record<string, string> = {};
  if (!isEuEnv) {
    bgfilter['state_permission'] = customer?.state || '';
  }

  bgfilter['country_permission'] = customer?.country || '';

  return { bgfilter };
}
